import { useState } from "react";
import { queryClient } from "../../utils/queryClient";
import { size } from "lodash";
import { toast } from "../../components/ui/Toast/useToast";
import { useRegisterLoyalty } from "../../hooks/react-query/useLoyalty";
import { Checkbox } from "../../components/ui";
import { SpinnerIcon } from "../../icons";
import { useNavigate } from "react-router-dom";
import usePersonStore from "../../store/personStore";
import { getLoyaltyInfoFn } from "../../transactions/loyalty/loyalty";

export const LoyaltyRegisterPage = () => {

  const [ loyaltyToS, setLoyaltyToS ] = useState(false)
  const navigate = useNavigate();
  const showRetailDashboard = usePersonStore((store) => store.showRetailDashboard);
  
  const { mutate: loyaltyEnroll, isLoading: isEnrollmentLoading } = useRegisterLoyalty()

  const handleLoyaltyEnrollment = async () => {
    try{
      loyaltyEnroll({ToS:loyaltyToS},{
        onSuccess: async (response) => {
          if (response.exceptions) {
            if (size(response.exceptions) > 0) {
              toast({
                variant: 'destructive',
                description: 'Κάτι πήγε λάθος! Η εγγραφή σου στο AVIS More, δεν ολοκληρώθηκε.',
              });
              navigate(showRetailDashboard ? "/dashboard" : "/portal/my-cars");
            }
          } else {
            toast({
              variant: 'success',
              description: 'Συγχαρητήρια! Η εγγραφή σου στο AVIS Loyalty, ολοκληρώθηκε με επιτυχία!',
            });           
            try {
              const freshLoyaltyInfo = await getLoyaltyInfoFn();
              const { setLoyaltyInfo, setIsLoyaltyEnrolled } = usePersonStore.getState();
              setIsLoyaltyEnrolled(!!freshLoyaltyInfo && freshLoyaltyInfo?.exceptions?.[0] !== 'User is not registered.');
              setLoyaltyInfo(freshLoyaltyInfo);
            } catch (e) {
              console.warn("Failed to fetch loyaltyInfo after enroll:", e);
              // still navigate if you want, but store might not be updated
            }

            navigate('/portal/loyalty/profile');
          }
        }
      })
    } catch (e) {
      console.warn(e)
    }
  }
 

  return (
    <div className='bg-black/30 flex flex-col justify-end items-start min-h-[calc(100vh-140px)] max-h-[calc(100vh-72px)] max-lg:min-h-[calc(100vh-140px)] max-lg:max-h-[calc(100vh-140px)]'>
      <div className="pb-14 pl-36">
        <p className='text-[104px] font-bold text-white leading-[0.6]'>Καλώς ήρθες</p>
        <p className='text-[104px] font-bold text-white pb-8'>στο Avis More</p>
        <p className='text-lg text-white'>Το πρόγραμμα επιβράβευσης που ενώνει όλες τις</p>
        <p className='text-lg text-white pb-20'>υπηρεσίες μας σε έναν ενιαίο κόσμο προνομίων.</p>

        <div className='flex flex-row gap-2 pb-6'>
          <Checkbox
            checked={loyaltyToS}
            onCheckedChange={(value) => setLoyaltyToS(value)}
            className="
              data-[state=checked]:bg-transparent
              data-[state=checked]:border-none
              data-[state=unchecked]:bg-transparent
              data-[state=unchecked]:border-white
              data-[state=unchecked]:rounded-md
            "
            checkboxClassName="
              rounded-md bg-transparent
              group-data-[state=checked]:bg-white
              group-data-[state=unchecked]:bg-transparent
            "
            checkIconClassName="
              group-data-[state=checked]:stroke-black
              group-data-[state=unchecked]:stroke-transparent
            "
          />
          <p className='text-sm text-white font-bold'>Aποδέχομαι τους{' '}
            <span 
              className='underline cursor-pointer' 
              onClick={()=>{window.open("https://www.myavis.gr/el/avis-more-terms-and-conditions", "_blank", "noopener,noreferrer");}}
            >Όρους & Προϋποθέσεις</span>
            {' και την '}
            <span 
              className='underline cursor-pointer' 
              onClick={()=>{window.open("https://www.myavis.gr/el/privacy-policy", "_blank", "noopener,noreferrer");}}
            >Πολιτική Απορρήτου</span>
            {' '}του Avis More.
          </p>
        </div>
        <button
          disabled={ !loyaltyToS || isEnrollmentLoading}
          className={`flex flex-row gap-2 px-[51px] py-3 text-white text-sm font-bold rounded-md ${!loyaltyToS || isEnrollmentLoading ? "bg-fadedgrey" : "bg-primary"}`}
          onClick={handleLoyaltyEnrollment}
          >
          {isEnrollmentLoading && <SpinnerIcon />}
          Εγγραφή
        </button>
      </div>
    </div>
    
  );
};

export default LoyaltyRegisterPage;
